import type { ConditionalRequestDefinition } from '@/utils/dehydrateRequestData/types';
import { hasHersteller } from '@/features/Sparten/shared/contractDehydration/kfz/conditionalRequestDefinitions';
import { kfzContractDehydrationDefinitions } from '@/features/Sparten/shared/contractDehydration/kfz/contractDehydration';

export const kradContractDehydrationDefinitions: ConditionalRequestDefinition[] =
  kfzContractDehydrationDefinitions.concat([hasHersteller]);
